// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-info-__slug-index-wrapper-ifeov{display:grid;grid-gap:24px}.pages-info-__slug-index-pageWrapper-bwnxp{padding-bottom:48px}.pages-info-__slug-index-pageWrapper-bwnxp.pages-info-__slug-index-mobile-dpgsr{padding-top:48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "pages-info-__slug-index-wrapper-ifeov",
	"pageWrapper": "pages-info-__slug-index-pageWrapper-bwnxp",
	"mobile": "pages-info-__slug-index-mobile-dpgsr"
};
module.exports = ___CSS_LOADER_EXPORT___;
